export interface ISpeedtest {
  activateSpeedtest?: boolean
  getSpeedtestStatus?: (value: TestStatus) => void
  getSpeedtestValues?: (value: SpeedtestValues) => void
  downloadLabel?: string
  uploadLabel?: string
  maxSpeed?: number
  dataSource?: ISpeedtestDataSource
  hasVisuals?: boolean
  trackingId: string
}

export interface SpeedtestValues {
  DOWNLOAD?: number
  UPLOAD?: number
  PING?: number
  IPINFO?: IIpInformation | null
}

export interface ISpeedtestDataSource {
  concurrency: number
  pingServerEndpoint: string
  targetServerCollection: Array<string>
}
export type ValueOf<T> = T[keyof T]

export const SPEED_TEST_STATUS = {
  INITIAL: 'INITIAL',
  DOWNLOAD: 'DOWNLOAD',
  UPLOAD: 'UPLOAD',
  PING: 'PING',
  COMPLETE: 'COMPLETE',
  ERROR: 'ERROR',
  IPINFO: 'IPINFO',
} as const
export type TestStatus = ValueOf<typeof SPEED_TEST_STATUS>

export interface IIpInformation {
  status: string
  country: string
  countryCode: string
  region: number
  regionName: string
  city: string
  zip: number
  lat: number
  lon: number
  timezone: string
  isp: string
  org: string
  as: string
  query: number
}
